const getDateFormated = (date) => {
  const arrayDate = date.toISOString().split("T");
  return `${arrayDate[0]}T00:00:00.000Z`;
};

export default getDateFormated;
